import { useState } from 'react'
import CampoMoeda from '../../componentes/CampoMoeda'
import { formatarMoeda } from '../../lib/formatos'
import { converterNumeroBR } from '../../lib/textoBR'
import { aceitaDigitacao } from '../../comissoes/conferencia'
import { diferencaDoTotalPago, totalPagoParaGuardar } from '../../comissoes/diferencas'

// Spec 2026-10-05, decisao dela: tocar no "Total da baixa" abre esta janela para
// digitar o TOTAL que a fabrica pagou. A diferenca vira debito/credito do mes da
// fornecedora. Nada e gravado aqui -- quem grava e o "Dar baixa".
export default function JanelaTotalPago({ calculado, texto, aoSalvar, aoFechar }: {
  calculado: number
  texto: string | null
  aoSalvar: (texto: string | null) => void
  aoFechar: () => void
}) {
  const [digitado, setDigitado] = useState(texto ?? calculado.toFixed(2).replace('.', ','))
  const pago = converterNumeroBR(digitado)
  const diferenca = diferencaDoTotalPago(calculado, pago !== null && pago >= 0 ? pago : null)

  const aviso = pago === null || pago < 0
    ? 'não entendi — vale o calculado'
    : diferenca > 0
      ? `a diferença de ${formatarMoeda(diferenca)} vira crédito do mês (a fábrica deve a você)`
      : diferenca < 0
        ? `a diferença de ${formatarMoeda(-diferenca)} vira débito do mês (você deve à fábrica)`
        : 'sem diferença'

  // Recusar a tecla em vez de aceitar e avisar depois -- mesma regra do valor da linha.
  function digitar(novo: string) {
    if (aceitaDigitacao(novo)) setDigitado(novo)
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end" onClick={aoFechar}>
      <div
        role="dialog" aria-modal="true" aria-label="Total pago"
        className="w-full bg-white rounded-t-2xl p-4 pb-6 space-y-3" onClick={(e) => e.stopPropagation()}
      >
        <p className="text-base font-semibold text-slate-800">Total pago pela fábrica</p>
        <p className="text-sm text-slate-600">Total calculado <span className="font-semibold">{formatarMoeda(calculado)}</span></p>
        <CampoMoeda
          aria-label="Total pago pela fábrica"
          value={digitado}
          onChange={digitar}
          className="w-full text-right text-lg border border-slate-300 rounded-lg px-3 py-2"
        />
        <p data-testid="aviso-total-pago" className={`text-sm ${diferenca > 0 ? 'text-sky-700' : diferenca < 0 ? 'text-red-700' : 'text-slate-500'}`}>
          {aviso}
        </p>
        {texto !== null && (
          <button type="button" onClick={() => aoSalvar(null)} className="w-full text-sm text-teal-700 underline underline-offset-2">
            Voltar ao calculado
          </button>
        )}
        <div className="grid grid-cols-2 gap-3">
          <button type="button" onClick={aoFechar} className="rounded-lg border border-slate-300 py-3 font-semibold text-slate-700">
            Cancelar
          </button>
          <button type="button" onClick={() => aoSalvar(totalPagoParaGuardar(digitado, calculado))} className="rounded-lg bg-teal-700 py-3 font-semibold text-white">
            Salvar
          </button>
        </div>
      </div>
    </div>
  )
}
